import React from 'react'
import { CheckedIcon, Label } from './views'

export interface CheckboxProps {
  name: string
  option: CheckboxOption
  checked?: boolean
  disabled?: boolean
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
}

type CheckboxOption = {
  name?: string
  label: string
  stateKey?: string
}

const Checkbox: React.FC<CheckboxProps> = ({ checked, disabled, option, onChange, ...rest }) => {
  return (
    <Label htmlFor={option.label}>
      {option.label}
      <input checked={checked} disabled={disabled} id={option.label} onChange={onChange} type={'checkbox'} {...rest} />
      {checked && <CheckedIcon />}
    </Label>
  )
}

export default Checkbox
